exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding0-5>div[data-v-5d53fd74] {\n  border-radius: 0.4rem;\n  margin-bottom: 0.4rem;\n  background: #fff;\n}\n.element:last-child .lineE0[data-v-5d53fd74] {\n  display: none;\n}\n.typeInfo[data-v-5d53fd74] {\n  background: #f6f6f6;\n  border-radius: 0.2rem;\n  padding: 0.3rem 0.4rem;\n  margin-bottom: 0.6rem;\n}", ""]);

// exports
